(function () {
  var RB_ACCOUNT_SELECTOR = '[data-rb-account-link], .rb-header__account';

  var RB_ACCOUNT_URL = '/account';

  function prepareRbAccountLink(link) {
    var href = link.getAttribute('href') || '';
    var needsHref = !href || href.indexOf('#k-hub') !== -1 || href.indexOf('/account') === -1;
    var needsIgnore = link.getAttribute('data-k-hub-ignore') !== '';

    if (!needsHref && !needsIgnore && !link.hasAttribute('data-drawer-options') &&
        !link.hasAttribute('data-drawer-delay') && !link.hasAttribute('data-drawer-delay-')) {
      return;
    }

    if (needsIgnore) link.setAttribute('data-k-hub-ignore', '');
    link.removeAttribute('data-drawer-options');
    link.removeAttribute('data-drawer-delay');
    link.removeAttribute('data-drawer-delay-');
    if (needsHref) link.setAttribute('href', RB_ACCOUNT_URL);
  }

  function prepareRbAccountLinks() {
    document.querySelectorAll(RB_ACCOUNT_SELECTOR).forEach(prepareRbAccountLink);
  }

  prepareRbAccountLinks();
  document.addEventListener('DOMContentLoaded', prepareRbAccountLinks);

  /* rb-digioh-tophat-desk-v1 — measure visible Digioh tophat; desktop header offsets via CSS var */
  var RB_DIGIOH_CHROME = '.rb-header, .rb-header-shell, .rb-trust-strip, .rb-age-gate, .rb-pdp-card, .rb-mobile-drawer, #t4s-mini_cart, #t4s-search-hidden';
  var RB_DIGIOH_SEL = [
    '#lightbox-wrapper',
    '[id^="lightbox-inline"]',
    '[id^="lightbox-overlay"]',
    '[id^="box_"]',
    '.lightbox-inline',
    '[class*="lightbox-inline"]',
    'iframe[src*="lightboxcdn"]',
    'iframe[src*="digioh"]',
    '[id*="Lightbox"]',
    '[id*="digioh"]',
    '[class*="digioh-"]'
  ].join(',');
  var lastDigiohPx = -1;

  function setDigiohTophatHeight(px) {
    var next = Math.max(0, Math.round(px));
    /* rb-pdp-native-tophat-keep-v1 — never clobber the pinned PDP offset */
    if (next === 0 && document.documentElement.classList.contains('rb-pdp-card-open')) {
      return lastDigiohPx < 0 ? 0 : lastDigiohPx;
    }
    /* rb-digioh-reserve-v1 — homepage.js measures the hidden iframe as 0 and
       was wiping the first-paint 110px slot before tophat.js implants. */
    /* rb-digioh-mobile-reserve-v3 — mobile holds the slot only once the banner is in flow,
       so nothing empty shows while Digioh loads. Before that a 0 here is correct. */
    if (next === 0 && document.documentElement.classList.contains('rb-digioh-reserve')) {
      if (window.innerWidth >= 1000 || document.documentElement.classList.contains('rb-digioh-inflow')) {
        next = 110;
      }
    }
    if (next === lastDigiohPx) return next;
    lastDigiohPx = next;
    var value = next + 'px';
    document.documentElement.style.setProperty('--rb-digioh-tophat-height', value);
    if (document.body) document.body.style.setProperty('--rb-digioh-tophat-height', value);
    return next;
  }

  function isRbThemeChrome(el) {
    return !!(el && el.closest && el.closest(RB_DIGIOH_CHROME));
  }

  function measureVisibleTopBar(el) {
    if (!el || isRbThemeChrome(el)) return 0;
    /* rb-digioh-banner-only-v2 — only reached if rb-digioh-tophat.js never loaded. A popup
       must not offset the header even on that path; it marks the ones it classifies. */
    if (el.closest && el.closest('.rb-digioh-modal')) return 0;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) return 0;
    var rect = el.getBoundingClientRect();
    if (rect.height < 16 || rect.height > 220) return 0;
    if (rect.top < -4 || rect.top > 20) return 0;
    if (rect.width < window.innerWidth * 0.72) return 0;
    return Math.round(rect.height);
  }

  function collectDigiohCandidates() {
    var found = [];
    try {
      document.querySelectorAll(RB_DIGIOH_SEL).forEach(function (el) { found.push(el); });
    } catch (err) {}
    var roots = document.body ? document.body.children : [];
    for (var i = 0; i < roots.length; i++) {
      var node = roots[i];
      var id = (node.id || '').toLowerCase();
      var cls = (typeof node.className === 'string') ? node.className.toLowerCase() : '';
      if (id.indexOf('lightbox') !== -1 || id.indexOf('digioh') !== -1 || cls.indexOf('lightbox') !== -1 || cls.indexOf('digioh') !== -1) {
        found.push(node);
      }
    }
    return found;
  }

  function measureDigiohTophat() {
    if (typeof window.rbSyncDigiohTophat === 'function') {
      return window.rbSyncDigiohTophat();
    }
    if (window.innerWidth <= 999) {
      return setDigiohTophatHeight(0);
    }
    var maxH = 0;
    collectDigiohCandidates().forEach(function (el) {
      var h = measureVisibleTopBar(el);
      if (!h && el.parentElement) h = measureVisibleTopBar(el.parentElement);
      if (h > maxH) maxH = h;
    });
    return setDigiohTophatHeight(maxH);
  }

  function isDesktopClient() {
    return !!(window.rbIsDesktopClient && window.rbIsDesktopClient());
  }

  /* Layout px, not getBoundingClientRect — html.rb-desktop-scale uses transform:scale,
     so viewport rects are shrunk and would undersize the in-flow header spacer. */
  function layoutBoxHeight(el) {
    if (!el) return 0;
    var h = el.offsetHeight;
    if (h > 0) return Math.ceil(h);
    var rect = el.getBoundingClientRect();
    var scale = 1;
    if (document.documentElement.classList.contains('rb-desktop-scale')) {
      scale = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rb-desktop-scale')) || 1;
    }
    if (scale > 0 && scale !== 1) return Math.ceil(rect.height / scale);
    return Math.ceil(rect.height);
  }

  function syncHeaderHeight() {
    /* Touch mobile: header/tophat are in document flow.
       Resized desktop windows keep a fixed header (rb-desktop-scale) — never zero the spacer.
       Native PDP / quickshop pins the header, so it still needs the Digioh offset —
       zeroing it slides the nav under the banner and it never returns. */
    var pdpOpen = document.documentElement.classList.contains('rb-pdp-card-open');
    var listingOrPdp = document.body.classList.contains('template-collection') ||
      document.body.classList.contains('template-product');
    if (listingOrPdp) {
      /* rb-chrome-page-top-v1 — Digioh + nav in document flow; no viewport spacer */
      document.documentElement.style.setProperty('--rb-header-height', '0px');
      if (document.body) document.body.style.setProperty('--rb-header-height', '0px');
      if (typeof window.rbSyncDigiohTophat === 'function') window.rbSyncDigiohTophat();
      return;
    }
    if (!isDesktopClient() && window.innerWidth <= 999) {
      /* rb-chrome-pin-v1 — other non-home pages keep Digioh + nav; only homepage zeros */
      if (pdpOpen || !document.body.classList.contains('template-index')) {
        if (typeof window.rbSyncDigiohTophat === 'function') window.rbSyncDigiohTophat();
        return;
      }
      setDigiohTophatHeight(0);
      document.documentElement.style.setProperty('--rb-header-height', '0px');
      document.documentElement.style.removeProperty('--rb-home-nav-block-height');
      document.documentElement.style.removeProperty('--rb-header-bar-height');
      document.body.style.removeProperty('--rb-home-nav-block-height');
      document.body.style.removeProperty('--rb-header-bar-height');
      /* rb-home-drawer-mobile-v1 — rb-scrolled is no longer cleared here. Mobile browsers
         fire resize when the URL bar collapses mid-scroll, which would pop the hidden
         chrome back open on every flick. The scroll handler owns that class now. */

      /* The pinned chrome is out of flow, so .rb-header-shell is the only thing holding the
         page down. Measure it instead of trusting the 36px + 98px estimate in CSS — the nav
         actually renders taller, and a short spacer tucks the hero under it. */
      var homeChromeH = layoutBoxHeight(document.querySelector('.rb-trust-strip')) +
        layoutBoxHeight(document.querySelector('.rb-header'));
      if (homeChromeH > 0) {
        document.body.style.setProperty('--rb-home-chrome-height', homeChromeH + 'px');
      }
      return;
    }

    var digiohH = measureDigiohTophat();
    var trust = document.querySelector('.rb-trust-strip');
    var header = document.querySelector('.rb-header');
    if (!trust && !header) return;

    var headerH = layoutBoxHeight(header);
    var trustH = layoutBoxHeight(trust);

    /*
      Homepage: fixed header + shell spacer. Must set on body — body.template-index
      redefines these vars and would override :root, so measuring html alone no-ops.
    */
    if (document.body.classList.contains('template-index')) {
      if (headerH > 0) {
        document.body.style.setProperty('--rb-home-nav-block-height', headerH + 'px');
        document.body.style.setProperty('--rb-header-bar-height', headerH + 'px');
        document.documentElement.style.setProperty('--rb-home-nav-block-height', headerH + 'px');
        document.documentElement.style.setProperty('--rb-header-bar-height', headerH + 'px');
      }
      return;
    }

    /* Always reserve full nav+tophat space — never collapse on rb-scrolled.
       Shrinking the shell during scroll/load locks scroll above true top. */
    var height = digiohH + trustH + headerH;
    if (height > 0) {
      document.documentElement.style.setProperty('--rb-header-height', height + 'px');
    }
  }

  syncHeaderHeight();
  window.rbSyncHeaderHeight = syncHeaderHeight;
  window.addEventListener('resize', syncHeaderHeight);
  window.addEventListener('rb-desktop-scale', syncHeaderHeight);
  window.addEventListener('load', syncHeaderHeight);
  document.addEventListener('DOMContentLoaded', syncHeaderHeight);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { syncHeaderHeight(); }).catch(function () {});
  }
  window.setTimeout(syncHeaderHeight, 100);
  window.setTimeout(syncHeaderHeight, 400);
  window.setTimeout(syncHeaderHeight, 1200);
  window.setTimeout(syncHeaderHeight, 2500);

  var digiohSyncTimer = 0;
  function scheduleDigiohHeaderSync() {
    if (digiohSyncTimer) return;
    digiohSyncTimer = window.setTimeout(function () {
      digiohSyncTimer = 0;
      if (typeof window.rbSyncDigiohTophat === 'function') window.rbSyncDigiohTophat();
      syncHeaderHeight();
    }, 80);
  }

  function observeDigiohTophat() {
    if (!document.body || typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(scheduleDigiohHeaderSync);
    mo.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });
  }

  if (document.body) {
    observeDigiohTophat();
  } else {
    document.addEventListener('DOMContentLoaded', observeDigiohTophat);
  }

  function initHeaderScrollHide() {
    /* rb-chrome-pin-v1 — Digioh + main nav stay fixed on every page but home */
    if (!document.body.classList.contains('template-index')) {
      document.body.classList.remove('rb-scrolled');
      document.documentElement.classList.remove('rb-pdp-nav-hidden');
      return;
    }
    var lastScrollY = window.scrollY;
    var isHidden = false;
    var scrollAccumulator = 0;
    var maxScrollWhileHidden = 0;
    var lastToggleAt = 0;
    var ticking = false;
    var trust = document.querySelector('.rb-trust-strip');
    var header = document.querySelector('.rb-header');
    var isHomepage = document.body.classList.contains('template-index');
    var showAtTop = 16;
    var hideAfterY = 72;
    var minDeltaHide = isHomepage ? 5 : 8;
    var minDeltaShow = isHomepage ? 5 : 48;
    var toggleCooldownMs = isHomepage ? 350 : 500;
    var scrollIntentThreshold = 2;

    function applyHiddenState(hidden, force) {
      if (hidden === isHidden) return;

      var now = Date.now();
      if (!force && now - lastToggleAt < toggleCooldownMs) return;

      isHidden = hidden;
      lastToggleAt = now;
      scrollAccumulator = 0;

      if (hidden) {
        maxScrollWhileHidden = window.scrollY;
        document.body.classList.add('rb-scrolled');
      } else {
        maxScrollWhileHidden = 0;
        document.body.classList.remove('rb-scrolled');
        syncHeaderHeight();
      }
    }

    function onHeaderTransitionEnd(event) {
      if (event.propertyName !== 'transform' || !isHidden) return;
      syncHeaderHeight();
    }

    if (trust) trust.addEventListener('transitionend', onHeaderTransitionEnd);
    if (header) header.addEventListener('transitionend', onHeaderTransitionEnd);

    function updateScrollState() {
      /* rb-home-drawer-mobile-v1 — both breakpoints drawer now. Quickshop is the one
         exception: it drives rb-scrolled from its own scroller, so leave the class alone
         while it's open or the two fight over the header. */
      if (document.documentElement.classList.contains('rb-pdp-card-open')) {
        lastScrollY = window.scrollY;
        return;
      }
      /* The mobile menu panel is anchored to the nav — sliding the nav out from under an
         open dropdown would leave it floating. Hold position until it closes. */
      if (document.body.classList.contains('rb-mobile-nav-open')) {
        lastScrollY = window.scrollY;
        return;
      }

      var scrollY = window.scrollY;
      var delta = scrollY - lastScrollY;

      if (scrollY <= showAtTop) {
        // Always restore at top — bypass cooldown so nav can't stick hidden
        applyHiddenState(false, true);
        syncHeaderHeight();
      } else if (isHidden) {
        if (isHomepage) {
          if (delta < -scrollIntentThreshold) {
            scrollAccumulator += delta;
            if (scrollAccumulator <= -minDeltaShow) {
              applyHiddenState(false);
            }
          } else if (delta > scrollIntentThreshold) {
            scrollAccumulator = 0;
          }
        } else {
          maxScrollWhileHidden = Math.max(maxScrollWhileHidden, scrollY);
          if (maxScrollWhileHidden - scrollY >= minDeltaShow) {
            applyHiddenState(false);
          }
        }
      } else if (delta > scrollIntentThreshold && scrollY > hideAfterY) {
        scrollAccumulator += delta;
        if (scrollAccumulator >= minDeltaHide) {
          applyHiddenState(true);
        }
      } else if (delta < -scrollIntentThreshold) {
        scrollAccumulator = 0;
      }

      lastScrollY = scrollY;
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateScrollState);
    }

    /* Start shown. Clear the class directly rather than through applyHiddenState — that
       early-returns when the state already matches, so a stale rb-scrolled from a
       restored scroll position would survive and the chrome would load hidden. */
    if (!document.documentElement.classList.contains('rb-pdp-card-open')) {
      document.body.classList.remove('rb-scrolled');
      isHidden = false;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  initHeaderScrollHide();

  function updateRbCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
    document.body.classList.toggle('t4s-cart-count-0', count === 0);
  }

  document.addEventListener('cart:update:count', function (event) {
    var count = event.detail && event.detail.count;
    if (count != null) updateRbCartCount(parseInt(count, 10) || 0);
  });

  function setNavMenuBridges() {
    if (window.innerWidth < 1000) return;
    document.querySelectorAll('.rb-header__dropdown').forEach(function (dropdown) {
      var menu = dropdown.querySelector('.rb-header__menu');
      if (!menu) return;
      dropdown.style.setProperty('--rb-menu-width', menu.offsetWidth + 'px');
    });
  }
  setNavMenuBridges();
  window.addEventListener('resize', setNavMenuBridges);

  document.querySelectorAll('.rb-header__dropdown').forEach(function (dropdown) {
    var pill = dropdown.querySelector('.rb-header__pill');
    if (!pill) return;

    dropdown.addEventListener('mouseleave', function () {
      if (dropdown.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    });
  });

  var carousel = document.querySelector('[data-hero-carousel]');
  if (!carousel) return;

  var slides = carousel.querySelectorAll('[data-hero-slide]');
  var dots = carousel.querySelectorAll('[data-hero-dot]');
  if (slides.length <= 1) return;
  var track = carousel.querySelector('[data-hero-track]');
  var rail = carousel.querySelector('[data-rb-hero-rail]');
  var bar = carousel.querySelector('[data-rb-hero-bar]');
  var thumb = carousel.querySelector('[data-rb-hero-thumb]');
  var current = 0;
  var timer;
  var baseDelay = parseInt(carousel.getAttribute('data-autoplay-ms') || '8000', 10);
  var currentDelay = baseDelay;
  var MOBILE_MAX = 999;
  var THUMB_MIN = 48;
  var scrollRaf = 0;
  var programmaticScroll = false;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  /* The section setting is the default; only slides that declare a brand
     override it, so choosing a dot colour in the theme editor actually sticks. */
  var defaultDotTheme = carousel.getAttribute('data-dot-theme-default') || 'dark';

  function updateDotTheme() {
    var controls = carousel.querySelector('.rb-hero__controls');
    var slide = slides[current];
    if (!controls || !slide) return;
    var theme = defaultDotTheme;
    if (slide.classList.contains('rb-hero__slide--canna')) theme = 'light';
    else if (slide.classList.contains('rb-hero__slide--kratom')) theme = 'dark';
    controls.setAttribute('data-dot-theme', theme);
  }

  function syncActiveClasses(index) {
    slides.forEach(function (slide, i) {
      var on = i === index;
      slide.classList.toggle('is-active', on);
      slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      /* aria-hidden must not be reachable by keyboard */
      if (on) slide.removeAttribute('tabindex');
      else slide.setAttribute('tabindex', '-1');
      if (dots[i]) {
        dots[i].classList.toggle('is-active', on);
        dots[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    });
    current = index;
    updateDotTheme();
  }

  var heroThumbState = { x: 0, target: 0, raf: 0, width: 0 };

  function syncHeroThumb(options) {
    if (!rail || !bar || !thumb || !track) return;
    if (!isMobile()) {
      rail.setAttribute('hidden', '');
      return;
    }
    rail.removeAttribute('hidden');
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var barWidth = bar.clientWidth || track.clientWidth;
    var thumbWidth = Math.max(
      THUMB_MIN,
      Math.round(barWidth * (track.clientWidth / Math.max(track.scrollWidth, 1)))
    );
    var maxOffset = Math.max(0, barWidth - thumbWidth);
    var progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
    var targetX = progress * maxOffset;
    var snap = !!(options && options.snap);

    if (heroThumbState.width !== thumbWidth) {
      heroThumbState.width = thumbWidth;
      thumb.style.width = thumbWidth + 'px';
    }

    heroThumbState.target = targetX;
    if (snap) {
      if (heroThumbState.raf) {
        window.cancelAnimationFrame(heroThumbState.raf);
        heroThumbState.raf = 0;
      }
      heroThumbState.x = targetX;
      thumb.style.transform = 'translate3d(' + targetX + 'px, 0, 0)';
      return;
    }

    if (heroThumbState.raf) return;
    heroThumbState.raf = window.requestAnimationFrame(function tick() {
      var delta = heroThumbState.target - heroThumbState.x;
      if (Math.abs(delta) < 0.2) {
        heroThumbState.x = heroThumbState.target;
        heroThumbState.raf = 0;
      } else {
        heroThumbState.x += delta * 0.45;
        heroThumbState.raf = window.requestAnimationFrame(tick);
      }
      thumb.style.transform = 'translate3d(' + heroThumbState.x + 'px, 0, 0)';
    });
  }

  function indexFromScroll() {
    if (!track || !track.clientWidth) return current;
    return Math.round(track.scrollLeft / track.clientWidth);
  }

  function goTo(index, fromScroll) {
    if (!slides.length) return;
    var nextIndex = (index + slides.length) % slides.length;
    syncActiveClasses(nextIndex);

    if (isMobile() && track && !fromScroll) {
      programmaticScroll = true;
      track.scrollTo({
        left: nextIndex * track.clientWidth,
        behavior: 'smooth'
      });
      window.setTimeout(function () {
        programmaticScroll = false;
        syncHeroThumb({ snap: true });
      }, 420);
    }
    syncHeroThumb({ snap: true });
  }

  function next() { goTo(current + 1); }

  /* Rotating a banner nobody can see burns battery and, on return to the tab,
     dumps every queued interval tick at once. Only run while visible on screen. */
  var heroVisible = true;

  function startAutoplay() {
    stopAutoplay();
    if (!heroVisible || document.hidden) return;
    timer = window.setInterval(next, currentDelay);
  }

  function stopAutoplay() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  function restartAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopAutoplay();
    else restartAutoplay();
  });

  if (typeof IntersectionObserver === 'function') {
    new IntersectionObserver(function (entries) {
      heroVisible = entries[entries.length - 1].isIntersecting;
      restartAutoplay();
    }, { threshold: 0 }).observe(carousel);
  }

  dots.forEach(function (dot, index) {
    dot.addEventListener('click', function () {
      goTo(index);
      restartAutoplay();
    });
  });

  if (track) {
    track.addEventListener('scroll', function () {
      if (!isMobile()) return;
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(function () {
        scrollRaf = 0;
        syncHeroThumb();
        if (programmaticScroll) return;
        var idx = indexFromScroll();
        if (idx !== current && idx >= 0 && idx < slides.length) {
          syncActiveClasses(idx);
        }
      });
    }, { passive: true });

    track.addEventListener('scrollend', function () {
      if (!isMobile()) return;
      programmaticScroll = false;
      var idx = indexFromScroll();
      if (idx !== current && idx >= 0 && idx < slides.length) {
        syncActiveClasses(idx);
      }
      syncHeroThumb({ snap: true });
      restartAutoplay();
    }, { passive: true });

    track.addEventListener('touchstart', function () {
      if (isMobile()) stopAutoplay();
    }, { passive: true });

    /* Mouse drag on phone-stage (resized desktop) — touch uses native pan-x */
    (function bindHeroPointerDrag() {
      var drag = null;
      track.addEventListener('pointerdown', function (e) {
        if (!isMobile()) return;
        if (e.pointerType === 'touch') return;
        if (e.button != null && e.button !== 0) return;
        drag = { id: e.pointerId, x: e.clientX, left: track.scrollLeft };
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.style.cursor = 'grabbing';
        stopAutoplay();
      });
      track.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        track.scrollLeft = drag.left - (e.clientX - drag.x);
      });
      function endDrag(e) {
        if (!drag) return;
        if (e && e.pointerId != null && e.pointerId !== drag.id) return;
        drag = null;
        track.style.cursor = 'grab';
        var idx = indexFromScroll();
        if (idx !== current && idx >= 0 && idx < slides.length) {
          syncActiveClasses(idx);
        }
        syncHeroThumb({ snap: true });
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
    })();
  }

  function setHoverSpeed(isHovered) {
    // Desktop-only: slow rotation by 50% while hovered.
    if (window.innerWidth < 1000) return;
    currentDelay = isHovered ? Math.round(baseDelay * 1.5) : baseDelay;
    restartAutoplay();
  }

  carousel.addEventListener('mouseenter', function () {
    setHoverSpeed(true);
  });

  carousel.addEventListener('mouseleave', function () {
    setHoverSpeed(false);
  });

  window.addEventListener('resize', function () {
    if (isMobile() && track) {
      track.scrollLeft = current * track.clientWidth;
    }
    syncHeroThumb({ snap: true });
  });

  syncHeroThumb({ snap: true });
  startAutoplay();
})();
